import { useRef } from 'react'
import copy from 'copy-to-clipboard'
import { useTranslation } from 'react-i18next'

import Dialog from 'components/Common/Modals/Dialog'

import TextField from './TextField'
import { Container, Footer, Cancel, Copy, Title } from './_styles'
import { useCloseModalByEsc } from 'utils/hooks/useCloseModalByEsc'

const ShareModal = props => {
  const { t } = useTranslation()

  const { toggleModal } = props
  const textFieldRef = useRef()

  const handleClickText = e => e.target.select()
  const handleCopyLink = () => {
    copy(document.location.href)
    toggleModal()
  }

  useCloseModalByEsc(toggleModal)

  return (
    <>
      <Dialog.Wrapper>
        <Container>
          <Dialog.Header
            title={t('wine.view.shareModal.header')}
            onClose={toggleModal}
          />
          <Dialog.Content padding='24px'>
            <Title>{t('wine.view.shareModal.title')}</Title>
            <TextField
              data-testid='wine-public-share-modal-url-input'
              onClick={handleClickText}
              ref={textFieldRef}
              readOnly
              defaultValue={document.location.href}
            />
            <Footer>
              <Cancel
                data-testid='wine-public-share-modal-cancel-button'
                onClick={toggleModal}
              >
                {t('wine.view.shareModal.cancel')}
              </Cancel>
              <Copy
                data-testid='wine-public-share-modal-copy-button'
                onClick={handleCopyLink}
              >
                {t('wine.view.shareModal.copyLink')}
              </Copy>
            </Footer>
          </Dialog.Content>
        </Container>
      </Dialog.Wrapper>
    </>
  )
}

export default ShareModal
